/**
 * A value that has not arrived yet, occupying exactly the space the value will.
 *
 * THE POINT IS GEOMETRY, NOT DECORATION. A refreshing quote used to swap a four-line
 * price block for a single "Pricing…" line, so every card below it jumped up and back
 * down on each drag of the slider. Rendering the real element with a placeholder INSIDE
 * it keeps the paragraph, its class, its font size and its margins exactly as they will
 * be — only the glyphs are missing, so nothing moves when they arrive.
 *
 * Sized in `ch` deliberately: one `ch` is the width of a digit in the current font, so a
 * placeholder for a seven-character price is seven characters wide in whatever type the
 * surrounding element uses. No hardcoded pixels, and it follows a font change.
 *
 * IT IS NOT A STALE VALUE. Nothing here remembers or displays a previous figure. A price
 * that no longer describes the configuration on screen is never shown; it is absent, and
 * this is the shape of its absence.
 *
 * Hidden from assistive technology. The surrounding component announces the pending
 * state in words; a screen reader gains nothing from a grey rectangle.
 */
export default function PendingValue({ width = '8ch' }: { width?: string }) {
  return <span aria-hidden="true" className="mm-pending-value" style={{ width }} />;
}
